var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencilFilled = function SvgPencilFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4537 2.60994C18.0632 2.21942 17.43 2.21942 17.0395 2.60994L14.115 5.53445L18.3697 9.78915L21.2942 6.86464C21.6847 6.47412 21.6847 5.84096 21.2942 5.45043L18.4537 2.60994ZM17.3059 10.8528L13.0512 6.59809L3.50321 16.3593L2.128 21.7753L7.75791 20.614L17.3059 10.8528Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencilFilled);
export default ForwardRef;